<template>
    <div class="about screen scrolling-screen">
        <h1 class="brandon title text-xxl">A B O U T</h1>
        <section>
            <p class="text-lg text-left">Polyworks is a software and hardware development company. The company's vision is building enjoyable, entertaining and useful products for our users. Whether it's a virtual experience or a home assistant, the intent remains the same: provide something positive. Our focuses include:</p>
            <br />
            <ul class="text-lg padding-32">
                <li>Mobile, Desktop and VR Games (as Polyworks Games)</li>
                <li>IoT / Smart Home</li>
                <li>Robotics</li>
            </ul>
            <br />
            <p class="text-lg text-left">A portion of all game proceeds is given back to charities. We feel strongly about game play being both enjoyable and having real-world impact. See individual game pages for more information.</p>
        </section>
    </div>
</template>
<script>
export default {
    name: "About",
};
</script>
<style scoped>
.padding-32 {
    padding: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue